import { useEffect } from "react";
import { GlobalEventListenerClass } from "@tmsw/powerups.services.global-event-listener";

const GlobalEventListener = GlobalEventListenerClass.getInstance();

export function useGlobalListener(type, callback, options) {
  // console.log('useEventListener', type, callback, options);
  useEffect(() => {
    const unsubscribe = GlobalEventListener.listen(type, callback, options);
    return () => unsubscribe();
  });
}

export const emitEvent = (eventName, detail) => GlobalEventListener.emit(eventName, detail);
export const subscribeEvent = (eventName, eventHandler, options) => GlobalEventListener.listen(eventName, eventHandler, options);
